import {
GetAllAccountType,GetOneAccountType,Error
} from "../type";
const initialState = {
  AccountsType: [],
  OneAccounts: [],
  loading: false,
};
const AccountTypeR = (state = initialState, action) => {
  switch (action.type) {
    case GetAllAccountType:
      return {
        ...state,
        AccountsType: action.payload,
        loading: false,
      };
    case GetOneAccountType:
      return {
        OneAccounts: action.payload,
        loading: false,
      };
    case Error:
      return {
        loading: false,
        AccountsType: action.payload,
      };
    default:
      return state;
  }
};
export default AccountTypeR;
